<template>
  <div class="ue-top">
    <div class="cia-container">
      <p>Projekt „Wzrost konkurencyjności firmy poprzez wprowadzenie nowej
        i&nbsp;innowacyjnej usługi jaką jest uruchomienie
        Centrum Innowacyjnej Archiwizacji w Katowicach.<br/>
        w ramach Regionalnego Programu Operacyjnego Województwa Śląskiego na lata 2014-2020
        Poddziałanie 3.2. Innowacje w MŚP.
      </p>
      <div class="ue-top__img">
        <img src="@/assets/ue.jpg" alt="Projekt „Wzrost konkurencyjności
        firmy poprzez wprowadzenie nowej
        i innowacyjnej usługi jaką jest uruchomienie
         Centrum Innowacyjnej Archiwizacji w Katowicach.
        w ramach Regionalnego Programu Operacyjnego Województwa Śląskiego na lata 2014-2020
        Poddziałanie 3.2. Innowacje w MŚP.">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ue-top',
};
</script>

<style lang="scss" scoped>
  .ue-top {
    text-align: center;
    padding: 40px 0;
    font-weight: 300;
    font-size: 12px;
    @media (min-width: 1200px) {
      font-size: 14px;
    }
    &__img {
      padding-top: 20px;
      img {
        display: block;
        margin: 0 auto;
        max-width: 100%;
      }
    }
  }
</style>
